/**
 * ThemeSelector.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../context/LanguageContext';
import { fmt } from '../i18n/format';
import './ThemeSelector.css';

const ThemeSelector = ({ compact = false }) => {
  const { currentTheme, changeTheme, availableThemes } = useTheme();
  const { t } = useLanguage();
  const ui = t.ui.theme;

  const handleThemeChange = (themeId) => {
    changeTheme(themeId);
  };

  if (compact) {
    return (
      <div className="theme-selector-compact">
        <label htmlFor="theme-select">{ui.label}</label>
        <select
          id="theme-select"
          value={currentTheme}
          onChange={(e) => changeTheme(e.target.value)}
          className="theme-select"
        >
          {availableThemes.map(theme => (
            <option key={theme.id} value={theme.id}>
              {theme.name}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className="theme-selector">
      <h3>{ui.chooseYours}</h3>
      <p className="theme-description">
        {ui.chooseHint}
      </p>
      
      <div className="theme-grid">
        {availableThemes.map(theme => (
          <button
            key={theme.id}
            className={`theme-card ${currentTheme === theme.id ? 'active' : ''}`}
            onClick={() => handleThemeChange(theme.id)}
            aria-label={fmt(ui.selectNamed, { name: theme.name })}
          >
            <div className="theme-preview">
              <div 
                className="preview-color preview-bg" 
                style={{ backgroundColor: theme.colors['--color-background'] }}
              />
              <div 
                className="preview-color preview-surface" 
                style={{ backgroundColor: theme.colors['--color-surface'] }}
              />
              <div 
                className="preview-color preview-primary" 
                style={{ backgroundColor: theme.colors['--color-primary'] }}
              />
              <div 
                className="preview-color preview-accent" 
                style={{ backgroundColor: theme.colors['--color-accent'] }}
              />
            </div>
            
            <div className="theme-info">
              <span className="theme-name">{theme.name}</span>
              {currentTheme === theme.id && (
                <span className="active-badge">✓ {ui.active}</span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector;
